import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, GridApi, ICellRendererParams, RowNode } from 'ag-grid-community';

@Component({
  selector: 'app-table-cell-checkbox-renderer',
  templateUrl: './table-cell-checkbox-renderer.component.html',
  styleUrls: ['./table-cell-checkbox-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellCheckboxRendererComponent implements ICellRendererAngularComp {
  value!: boolean;
  onChange!: (val: boolean, record: any) => void;
  private column!: ColDef;
  private api!: GridApi;
  private node!: RowNode;
  editable = false;
  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.setValue(params);
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.setValue(params);
    this.cdr.detectChanges();
    return true;
  }

  private setValue(params: ICellRendererParams): void {
    this.value = params.getValue ? params.getValue() : false;
    this.onChange = params.colDef!.cellRendererParams!.onChange;
    this.column = params.colDef!;
    this.api = params.api;
    this.node = params.node;
    this.editable = Boolean(this.column.editable) || false;
  }
}
